import React from 'react'
import { Link } from 'react-router-dom'

import logo from '../../assets/imgs/logo-rc.png'

//STYLES
import './Header.css'

export default function Header() {
  return (
    <header className='App-header'>
        <Link to="/bar">
            <img src={logo} alt="Riches-Claires logo" className="logo" />
        </Link>
        <h1 className='app-title'>RC BAR</h1>
    </header>
  )
}
